<template>
  <section class="home-bed">
    <div class="img-bed">
      <title-bar title="订单查询"></title-bar>
    </div>
    <ul class="type-list">
      <li v-for="(item, index) in typeList"
          :key="index"
          @click="choosePay(index)"
          :class="index==typeNum?'checked':''">{{item}}</li>
    </ul>
    <div class="menu-list">
      <list-add v-if="typeNum==0"></list-add>
      <list-lost v-if="typeNum==2"
                 :lostList="lostList"></list-lost>
      <list-year-checked v-if="typeNum==1"
                         :yearList="yearList"></list-year-checked>
      <list-new v-if="typeNum==3"
                :newList="newList"></list-new>

    </div>

  </section>
</template>

<script>

import TitleBar from '@/components/TitleBar'
import listAdd from '@/components/listAdd'
import listLost from '@/components/listLost'
import listYearChecked from '@/components/listYearChecked'
import listNew from '@/components/listNew'
import { queryCardReview, queryCardNewApply } from '@/api/list'

export default {
  name: 'listAll',
  data () {
    return {
      typeList: ['充值', '年审', '挂失·补办', '新办'],
      typeNum: 0,
      yearList: [],
      lostList: [],
      newList: []
    }
  },
  components: {
    TitleBar,
    listAdd,
    listLost,
    listYearChecked,
    listNew

  },

  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  mounted () {

  },
  methods: {
    yearLost () {
      const params = {
        businessType: "2"
      }
      queryCardNewApply(params).then(data => {
        if (data.respCode === '01') {
          this.lostList = data.data.data;
          // this.isShow_sure = true
        } else {
          // this.msg = data.respMsg;
          // this.isShow_fail = true
        }
      }).catch(err => {
        this.$eventBus.$emit('getTipsInfo', {
          msg: err
        })
      })

    },
    yearAdd () {
      const params = {
        businessType: '1'
      }
      queryCardNewApply(params).then(data => {
        if (data.respCode === '01') {
          this.newList = data.data.data
        } else {
          this.$eventBus.$emit('getTipsInfo', {
            msg: data.respMsg
          })
        }
      }).catch(err => {
        this.$eventBus.$emit('getTipsInfo', {
          msg: err
        })
      })

    },
    yearChecked () {
      const params = {

      }
      queryCardReview(params).then(data => {
        if (data.respCode === '01') {
          console.log(data.data)
          this.yearList = data.data.reviewList
          console.log(this.yearList)
        } else {
          this.$eventBus.$emit('getTipsInfo', {
            msg: data.respMsg
          })
        }
      }).catch(err => {
        this.$eventBus.$emit('getTipsInfo', {
          msg: err
        })
      })

    },
    choosePay (index) {
      this.typeNum = index;
      if (index == 1) {
        this.yearChecked()
      } else if (index == 2) {
        this.yearLost()
      } else if (index == 3) {
        this.yearAdd()
      }
    },

    goRouter (router) {
      if (this.loading) {
        this.$router.push({
          name: router
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  background: #f5f6f8;
  min-height: 100%;
  // overflow: scroll;
}
.img-bed {
  font-size: 0;
  background: #fff;
}
.type-list {
  width: calc(100% - 64px);
  height: 94px;
  line-height: 94px;
  margin-left: 32px;
  margin-bottom: 8px;
  display: flex;
  // align-items: center;
  li {
    width: 25%;
    font-size: 30px;
    font-family: 宋体;
    font-weight: 400;
    color: #8f98a8;
  }
  .checked::after {
    width: 60px;
    content: "";
    display: block;
    margin: -24px auto;
    border-bottom: 6px solid #2489ff;
  }
  .long::after {
    width: 135px;
    content: "";
    display: block;
    margin: -24px auto;
    border-bottom: 6px solid #2489ff;
  }
}
.menu-list {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  // overflow: scroll;

  > .list-bed {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    // flex-wrap: wrap;
    width: 100%;

    > .list-li {
      // border-bottom: 3px solid #eee;
      width: calc(100% - 64px);
      // height: 330px;
      margin-bottom: 16px;
      padding-bottom: 4px;
      // box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #fff;

      .li-con {
        width: calc(100% - 48px);
        padding-top: 16px;
        position: relative;
        .li-btn {
          position: absolute;
          top: 24px;
          right: 0px;
          width: 120px;
          height: 54px;
          line-height: 54px;
          background: #2489ff;
          border-radius: 27px 27px 27px 27px;
          font-size: 28px;
          font-family: 宋体;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.9803921568627451);
        }

        .li-box {
          height: 37px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          text-align: left;
          margin-bottom: 20px;

          .blue {
            color: #2489ff !important;
          }
          .orange {
            color: #ef8441 !important;
          }
          .red {
            color: #ef4141 !important;
          }
          .li-key {
            width: 160px;
            height: 100%;
            font-size: 26px;
            font-family: 宋体;
            font-weight: 400;
            color: #8f98a8;
          }
          .li-val {
            width: calc(100% - 160px);
            height: 100%;
            font-size: 26px;
            font-family: 宋体;
            font-weight: 400;
            color: #333333;
            display: flex;
            justify-content: space-between;
          }
        }
      }
    }
  }
}
</style>
